<div class="card section">
    <h5 class="section-title">Update Password</h5>
    <br>
    <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
        <div class="row g-3">
            <div class="input-group">
                <span class="input-group-addon ">
                    <i class="glyphicon glyphicon-user"></i>
                </span>
                <input type="text" disabled="true" id="username" name="username" class="form-control removeBackgroud"
                    placeholder="Username" [value]="this.constantService.user.username">
            </div>
            <!-- New Password -->
            <div class="col-md-6 d-flex align-items-center">
                <label class="form-label-fixed me-2 mb-0">
                    New Password <span class="required">*</span>
                </label>

                <div class="password-wrapper flex-grow-1">
                    <input name="newPassword" id="newPassword" [type]="showNewPassword ? 'text' : 'password'" class="form-control"
                        formControlName="newPassword" placeholder="Enter new password" />

                    <span class="toggle-icon" (click)="toggleNewPassword()">
                        <i [class]="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </span>
                </div>
            </div>
            <div class="col-12">
                @if (passwordForm.get('newPassword')?.touched &&
                passwordForm.get('newPassword')?.errors) {

                @if (passwordForm.get('newPassword')?.errors?.['required']) {
                <small class="error">Password is required</small>
                }

                @if (passwordForm.get('newPassword')?.errors?.['pattern']) {
                <small class="error">
                    Password must contain:
                    1 uppercase, 1 lowercase, 1 number,
                    1 special character, and be at least 8 characters long
                </small>
                }
                }
            </div>

            <!-- Confirm Password -->
            <div class="col-md-6 d-flex align-items-center">
                <label class="form-label-fixed me-2 mb-0">
                    Confirm Password <span class="required">*</span>
                </label>

                <div class="password-wrapper flex-grow-1">
                    <input name="confirmPassword" id="confirmPassword"  [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"
                        formControlName="confirmPassword" placeholder="Confirm password" />

                    <span class="toggle-icon" (click)="toggleConfirmPassword()">
                        <i [class]="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                    </span>
                </div>
            </div>

            <div class="col-12">
                @if (passwordForm.get('confirmPassword')?.touched &&
                passwordForm.get('confirmPassword')?.errors?.['required']) {
                <small class="error">Confirm password is required</small>
                }

                @if (passwordForm.errors?.['passwordMismatch'] &&
                passwordForm.get('confirmPassword')?.touched) {
                <small class="error">Passwords do not match</small>
                }
            </div>

            <div class="col-12 text-end">
                <button id ="updatePasswordButton" class="btn btn-md btn-primary btn-block defaultBtnColor" type="submit"
                    [disabled]="passwordForm.invalid">
                    Update Password
                    @if(loading){
                    <img alt="loader" style="text-align:center"
                        src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                    }
                </button>
            </div>
        </div>
    </form>

    @if(error){
    <div class="alert alert-danger">{{error}}</div>
    }
</div>